import { Component, HostBinding, inject, OnDestroy, OnInit } from '@angular/core';
import {
    ApiService,
    PageService,
    PageType,
    SettingsService,
    TranslateService,
    ZoneService,
} from '@gallaghercp/core-frontend';
import { TranslateService as TranslateProvider } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_CONFIG } from '@core-app/app.config';

@Component({
    selector: 'core-footer',
    templateUrl: './footer.component.html',
    standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {
    private pages = inject(PageService);
    private api = inject(ApiService);
    private settings = inject(SettingsService);
    protected translate = inject(TranslateService);
    protected zoneService = inject(ZoneService);

    @HostBinding('style.display') displayStyle: string = 'block';
    copyright: string | undefined = APP_CONFIG.copyright;
    year: number = new Date().getFullYear();

    pages$?: Observable<any>;
    logoUrl?: any;
    darkMode?: boolean;
    subscription: Subscription = new Subscription();
    translateProvider: TranslateProvider = inject(TranslateProvider);
    cookiePolicy?: string = (APP_CONFIG as any).cookiePolicy;

    protected logoInvertedUrl!: string;
    protected logoTransparentUrl!: string;

    ngOnInit() {
        this.subscription.add(
            this.api.zoneChangeEmit.subscribe(() => {
                this.getPages();
            }),
        );

        this.subscription.add(
            this.translateProvider.onLangChange.subscribe(() => {
                this.getPages();
            }),
        );

        this.subscription.add(
            this.settings.isDarkMode().subscribe((state: any) => {
                this.darkMode = state;
                this.updateLogoUrl();
            }),
        );

        this.subscription.add(
            this.settings.getInvertedLogo().subscribe((logoUrl: any) => {
                this.logoInvertedUrl = logoUrl;
                this.updateLogoUrl();
            }),
        );

        this.subscription.add(
            this.settings.getTransparentLogo().subscribe((logoUrl: any) => {
                this.logoTransparentUrl = logoUrl;
                this.updateLogoUrl();
            }),
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    updateLogoUrl(): void {
        this.logoUrl = !this.darkMode ? this.logoInvertedUrl : this.logoTransparentUrl;
    }

    private getPages(): void {
        this.pages$ = this.pages.getPages().pipe(
            map((pages: PageType[]) =>
                pages.map((page: PageType) => ({
                    ...page,
                    name: this.translate.getPageSpecific(page, 'name'),
                    description: this.translate.getPageSpecific(page, 'description'),
                    url: this.zoneService.injectZoneCodeUrl(this.translate.getPageSpecific(page, 'url')),
                    tags: this.translate.getPageSpecific(page, 'tags'),
                })),
            ),
        );
    }
}
